/**
 * 教学页的按钮：请求进行中、暂时不能按时用 aria-disabled 并拦掉点击，不真的 disabled——真禁用会把键盘焦点丢到 body，
 * 回包慢一点（真后端）焦点就回不来（设计评审第二轮高 1）。样子用全站的 .ps-btn（ui.css 里 [aria-disabled="true"] 和 :disabled 同一套外观）。
 * 读屏：aria-busy 念「正在…」，aria-disabled 念「不可用」；describedBy 指向说明为什么不能按的那句。
 */
import type { ButtonHTMLAttributes, ReactNode, Ref } from "react";

export function TeachButton({
  variant = "secondary", block, busy = false, unavailable = false, describedBy, buttonRef, className, onClick, children, type = "button", ...rest
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled"> & {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  block?: boolean;
  busy?: boolean;
  unavailable?: boolean;
  describedBy?: string;
  buttonRef?: Ref<HTMLButtonElement>;
  children: ReactNode;
}) {
  const blocked = busy || unavailable;
  return (
    <button
      {...rest}
      ref={buttonRef}
      type={type}
      className={["ps-btn", `ps-btn--${variant}`, block ? "ps-btn--block" : "", className ?? ""].filter(Boolean).join(" ")}
      aria-busy={busy || undefined}
      aria-disabled={blocked || undefined}
      aria-describedby={describedBy}
      onClick={(event) => {
        if (blocked) {
          event.preventDefault();
          return;
        }
        onClick?.(event);
      }}
    >
      {children}
    </button>
  );
}
